import axios from 'axios';
import { useCallback } from 'react';

const BASE_PATH = 'https://api.hsforms.com/submissions';
const VERSION = 'v3';

export interface HubspotFieldData {
  objectTypeId?: string;
  name: string;
  value: string;
}

export interface HubspotSubmitFormInput {
  portalId: string;
  formId: string;
  fields: HubspotFieldData[];
}

interface UseHubspotFormInterface {
  onSubmitForm: (input: HubspotSubmitFormInput) => Promise<void>;
}

export async function submitHubspotForm({
  portalId,
  formId,
  fields,
}: HubspotSubmitFormInput): Promise<void> {
  const fieldsList = fields.map(field => ({
    name: field.name,
    value: field.value,
  }));

  await axios.post(
    `${BASE_PATH}/${VERSION}/integration/submit/${portalId}/${formId}`,
    {
      fields: fieldsList,
      context: {
        pageUri: window.location.href,
        pageName: document.title || '',
      },
    },
    {
      headers: { 'Content-Type': 'application/json' },
      validateStatus: status => status < 500,
    },
  );
}

export function useHubspotForm(): UseHubspotFormInterface {
  const handleSubmitForm = useCallback(async (input: HubspotSubmitFormInput) => {
    await submitHubspotForm(input);
  }, []);

  return {
    onSubmitForm: handleSubmitForm,
  };
}
